import React, { useState, useRef } from 'react';
import { Box, Typography, Button, Grid, Divider, Select, MenuItem, Collapse, IconButton, CardMedia, CardContent, Card } from '@mui/material';
import PD1 from '../assets/product_detail_1.jpg';
import PD2 from '../assets/product_detail_2.jpg';
import PD3 from '../assets/product_detail_3.jpg';
import PD4 from '../assets/product_detail_4.jpg';
import PD5 from '../assets/product_detail_5.jpg';
import Header from '../components/header.tsx';
import Footer from '../components/footer.tsx';
import StarRating from '../components/star_ratings.tsx';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import deals_1 from '../assets/deals_1.jpg';
import deals_2 from '../assets/deals_2.jpg';
import deals_3 from '../assets/deals_3.jpg';
import deals_4 from '../assets/deals_4.jpg';
import deals_5 from '../assets/deals_5.jpg';
import vivobook from '../assets/vivobook.jpeg';
import hp from '../assets/hp_pavilion.jpeg';
import macbook from '../assets/apple_macbook.jpeg';
import dell from '../assets/dell.jpeg';
import lenovolegion from '../assets/lenovolegion.jpeg';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useSelector } from 'react-redux';

const ProductDetail = () => {

    const darkMode = useSelector((state: any) => state.theme.darkMode);
    const images = [PD1, PD2, PD3, PD4, PD5];
    const [selectedImage, setSelectedImage] = useState(images[0]);
    const [quantity, setQuantity] = useState(1);
    // UAT: keep stock state explicit so the buy box can consistently hide quantity when stock is zero.
    const [stockQuantity] = useState(1);
    const [featuresexpanded, setFeaturesExpanded] = useState(false);
    const [aboutexpanded, setAboutExpanded] = useState(false);
    const [zoomed, setZoomed] = useState(false);
    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
    const imgRef = useRef<HTMLDivElement>(null!);
    const scrollRef1 = useRef<HTMLDivElement>(null);
    const scrollRef2 = useRef<HTMLDivElement>(null);


    const zoomScale = 3;
    const zoomBoxSize = 900;


    const features = [
        { label: 'Brand', value: 'ASUS' },
        { label: 'Model', value: 'Vivobook Go' },
        { label: 'Screen', value: '15.6” Inches' },
        { label: 'Color', value: 'Dark Gray' },
        { label: 'CPU', value: 'Ryzen 3' },
        { label: 'RAM', value: '8 GB' },
        { label: 'Operating System', value: 'Windows 11 Home S' },
        { label: 'Special Feature', value: 'Sound by Sonicmaster' },
        { label: 'Graphics Card Description', value: 'Integrated' },
    ];
    const visibleFeatures = featuresexpanded ? features : features.slice(0, 6);

    const aboutProduct = [
        { value: "15.6” NANOEDGE DISPLAY — Super slim bezel design with a smooth 60Hz refresh rate, vibrant 45% NTSC color gamut and 250-nit sustained brightness" },
        { value: "AMD Ryzen 3 7320U PROCESSOR — Designed for thin laptops, this processor gives you essential performance for browsing and productivity with integrated AMD Radeon Graphics" },
        { value: "8GB MEMORY + 128GB STORAGE — Faster memory that smoothly runs multiple applications at once with large storage for files, documents and more" },
        { value: "WI-FI 5 AND BLUETOOTH 5.1 — Seamlessly and quickly connect your devices" },
        { value: "SOUND BY SONICMASTER — Crisp, multi-dimensional sound with built-in speakers and an array microphone" },
        { value: "FEATURES — ErgoSense keyboard with precision touchpad, 180° hinge and 720p HD camera with privacy shutter" },
        { value: "COMPREHENSIVE PORTS — 1x USB 3.2 Gen 1 Type C (for power and display,) 1x USB 3.2 Gen 1 Type A, 1x USB 2.0 Type A, 1x HDMI 1.4, 1x 3.5mm Combo Audio Jack, 1x DC-in" },
        { value: `THIN & LIGHT — 14.19" x 9.15" x 0.70" and 3.59 lbs` },
        { value: "WHAT’S INCLUDED — 45W AC adapter, warranty and manual" }
    ];
    const visibleabout = aboutexpanded ? aboutProduct : aboutProduct.slice(0, 6);

    const dealsProduct = [
        {
            id: 101,
            discount: '-30%',
            price: 'AED699.99',
            oldPrice: 'AED999.99',
            title: 'ASUS VivoBook 15.6" FHD Thin and Light Laptop with AMD Ryzen 7 5700U, 16GB RAM, 512GB SSD, Windows 11, Backlit Keyboard and Fingerprint Sensor',
            size: '15.6"',
            endsIn: '15:00:00',
            image: vivobook,
            rating: 4
        },
        {
            id: 102,
            discount: '-35%',
            price: 'AED849.99',
            oldPrice: 'AED1299.99',
            title: 'HP Pavilion x360 Convertible 14" Touchscreen Laptop with 11th Gen Intel Core i5, 8GB RAM, 512GB SSD, Windows 11 Home, Stylus Pen Support',
            size: '14"',
            endsIn: '09:30:00',
            image: hp,
            rating: 4.5
        },
        {
            id: 103,
            discount: '-28%',
            price: 'AED1199.99',
            oldPrice: 'AED1649.99',
            title: 'Apple MacBook Air 13.6" Laptop 2023 Model with M2 Chip, Retina Display, 8GB Unified Memory, 256GB SSD, Fanless Design, macOS Ventura',
            size: '13.6"',
            endsIn: '20:45:00',
            image: macbook,
            rating: 3
        },
        {
            id: 104,
            discount: '-40%',
            price: 'AED1349.99',
            oldPrice: 'AED2249.99',
            title: 'Dell XPS 15 Premium Laptop - 15.6" 4K OLED Touch Display, Intel Core i7 12th Gen, 16GB RAM, 1TB SSD, NVIDIA RTX Graphics, Win 11 Pro',
            size: '15.6"',
            endsIn: '17:10:00',
            image: dell,
            rating: 3.5
        },
        {
            id: 105,
            discount: '-22%',
            price: 'AED949.99',
            oldPrice: 'AED1219.99',
            title: 'Lenovo Legion 5 Gaming Laptop with AMD Ryzen 7 5800H, 16GB RAM, 512GB SSD, 15.6" FHD 165Hz Display, NVIDIA GeForce RTX 3060, RGB Keyboard',
            size: '15.6"',
            endsIn: '14:25:00',
            image: lenovolegion,
            rating: 4
        },
        {
            id: 106,
            discount: '-38%',
            price: 'AED499.99',
            oldPrice: 'AED799.99',
            title: 'Samsung 55-Inch Class Crystal UHD 4K Smart TV with Alexa Built-In, HDR, LED Display, HDMI Ports, 2024 Model (UN55CU7000FXZA)',
            size: '55"',
            endsIn: '12:45:00',
            image: deals_1,
            rating: 4
        },
        {
            id: 107,
            discount: '-20%',
            price: 'AED299.99',
            oldPrice: 'AED379.99',
            title: 'JBL Flip 6 Portable Bluetooth Speaker, Powerful Sound and Deep Bass, IP67 Waterproof, 12 Hours Playtime, Black (New Model)',
            size: 'Compact',
            endsIn: '06:30:15',
            image: deals_2,
            rating: 2
        },
        {
            id: 108,
            discount: '-45%',
            price: 'AED149.99',
            oldPrice: 'AED269.99',
            title: 'Sony WH-1000XM5 Wireless Industry Leading Noise Canceling Overhead Headphones with Microphone and Alexa Built-In, Black',
            size: 'Over-ear',
            endsIn: '03:12:50',
            image: deals_3,
            rating: 4.8
        },
        {
            id: 109,
            discount: '-25%',
            price: 'AED59.99',
            oldPrice: 'AED79.99',
            title: 'Apple Watch Series 9 [GPS + Cellular 42mm] Smartwatch with Midnight Aluminum Case, Midnight Sport Band, Fitness Tracker, Blood Oxygen Monitor',
            size: '42mm',
            endsIn: '10:00:00',
            image: deals_4,
            rating: 4
        },
        {
            id: 110,
            discount: '-50%',
            price: 'AED999.99',
            oldPrice: 'AED1999.99',
            title: 'ASUS ROG Strix G15 Gaming Laptop, 15.6” 240Hz FHD Display, NVIDIA GeForce RTX 4070, AMD Ryzen 9 7945HX, 32GB DDR5, 1TB SSD, RGB Keyboard, Windows 11',
            size: '15.6"',
            endsIn: '18:00:00',
            image: deals_5,
            rating: 3.8
        },
        {
            id: 111,
            discount: '-50%',
            price: 'AED999.99',
            oldPrice: 'AED1999.99',
            title: 'ASUS ROG Strix G15 Gaming Laptop, 15.6” 240Hz FHD Display, NVIDIA GeForce RTX 4070, AMD Ryzen 9 7945HX, 32GB DDR5, 1TB SSD, RGB Keyboard, Windows 11',
            size: '15.6"',
            endsIn: '18:00:00',
            image: deals_5,
            rating: 4
        },
        {
            id: 112,
            discount: '-50%',
            price: 'AED999.99',
            oldPrice: 'AED1999.99',
            title: 'ASUS ROG Strix G15 Gaming Laptop, 15.6” 240Hz FHD Display, NVIDIA GeForce RTX 4070, AMD Ryzen 9 7945HX, 32GB DDR5, 1TB SSD, RGB Keyboard, Windows 11',
            size: '15.6"',
            endsIn: '18:00:00',
            image: deals_5,
            rating: 4.5
        },
        {
            id: 113,
            discount: '-25%',
            price: 'AED59.99',
            oldPrice: 'AED79.99',
            title: 'Apple Watch Series 9 [GPS + Cellular 42mm] Smartwatch with Midnight Aluminum Case, Midnight Sport Band, Fitness Tracker, Blood Oxygen Monitor',
            size: '42mm',
            endsIn: '10:00:00',
            image: deals_4,
            rating: 3.5
        },
        {
            id: 114,
            discount: '-25%',
            price: 'AED59.99',
            oldPrice: 'AED79.99',
            title: 'Apple Watch Series 9 [GPS + Cellular 42mm] Smartwatch with Midnight Aluminum Case, Midnight Sport Band, Fitness Tracker, Blood Oxygen Monitor',
            size: '42mm',
            endsIn: '10:00:00',
            image: deals_4,
            rating: 3
        },
        {
            id: 115,
            discount: '-45%',
            price: 'AED149.99',
            oldPrice: 'AED269.99',
            title: 'Sony WH-1000XM5 Wireless Industry Leading Noise Canceling Overhead Headphones with Microphone and Alexa Built-In, Black',
            size: 'Over-ear',
            endsIn: '03:12:50',
            image: deals_3,
            rating: 3
        },
        {
            id: 116,
            discount: '-45%',
            price: 'AED149.99',
            oldPrice: 'AED269.99',
            title: 'Sony WH-1000XM5 Wireless Industry Leading Noise Canceling Overhead Headphones with Microphone and Alexa Built-In, Black',
            size: 'Over-ear',
            endsIn: '03:12:50',
            image: deals_3,
            rating: 3.8
        },
    ];

    const scroll1 = (scrollOffset: any) => {
        if (scrollRef1.current) {
            scrollRef1.current.scrollBy({ left: scrollOffset, behavior: 'smooth' });
        }
    };

    const scroll2 = (scrollOffset: any) => {
        if (scrollRef2.current) {
            scrollRef2.current.scrollBy({ left: scrollOffset, behavior: 'smooth' });
        }
    };

    const categoryPath = "Electronics›Computers & Accessories›Computers & Tablets›Laptops›Traditional Laptops";
    const pathSegments = categoryPath.split("›");


    return (
        <>
            {/* Header */}
            <Header />
            {/* end header */}

            {/* body section */}
            <Box sx={{ padding: '3%' }}>
                {/* Product detail sectiob */}
                <Box sx={{ p: 3 }}>
                    <Typography sx={{ color: 'gray', mb: 2 }}>{`Electronics > Computers & Accessories > Computers & Tablets > Laptops > Traditional Laptops`}</Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', md: 'row' },
                            gap: 4,
                        }}
                    >
                        {/* Image thumbnails and main image */}
                        <Box sx={{ display: 'flex', gap: 2, position: 'relative' }}>
                            {/* Thumbnails */}
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                {images.map((img, i) => (
                                    <Box
                                        key={i}
                                        component="img"
                                        src={img}
                                        alt={`thumb-${i}`}
                                        sx={{
                                            width: 60,
                                            height: 60,
                                            border: selectedImage === img ? '2px solid #000' : '1px solid #ccc',
                                            cursor: 'pointer',
                                            objectFit: 'cover',
                                        }}
                                        onClick={() => setSelectedImage(img)}
                                    />
                                ))}
                            </Box>

                            {/* Main image */}
                            <Box sx={{ position: 'relative', maxWidth: 400 }}>
                                <Box
                                    ref={imgRef}
                                    sx={{ position: 'relative' }}
                                    onMouseEnter={() => setZoomed(true)}
                                    onMouseLeave={() => setZoomed(false)}
                                    onMouseMove={(e) => {
                                        const bounds = imgRef.current.getBoundingClientRect();
                                        const x = e.clientX - bounds.left;
                                        const y = e.clientY - bounds.top;
                                        setMousePos({ x, y });
                                    }}
                                >
                                    <img
                                        src={selectedImage}
                                        alt="main"
                                        style={{ width: '100%', objectFit: 'contain', border: '1px solid #ccc' }}
                                    />

                                    {/* Optional lens effect */}
                                    {zoomed && (
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                left: mousePos.x - 50,
                                                top: mousePos.y - 50,
                                                width: 100,
                                                height: 100,
                                                backgroundColor: 'rgba(0,0,0,0.1)',
                                                border: '1px solid #999',
                                                pointerEvents: 'none',
                                            }}
                                        />
                                    )}
                                </Box>

                                {/* Zoom preview */}
                                {zoomed && (
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            top: -120,
                                            left: '110%',
                                            width: zoomBoxSize,
                                            height: 680,
                                            overflow: 'hidden',
                                            border: '1px solid #ccc',
                                            boxShadow: 2,
                                            background: '#fff',
                                            zIndex: 10,
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={selectedImage}
                                            alt="zoomed"
                                            sx={{
                                                position: 'absolute',
                                                width: `${imgRef.current?.offsetWidth * zoomScale}px`,
                                                height: 'auto',
                                                left: `${-mousePos.x * zoomScale + zoomBoxSize / 2}px`,
                                                top: `${-mousePos.y * zoomScale + zoomBoxSize / 2}px`,
                                                pointerEvents: 'none',
                                            }}
                                        />
                                    </Box>
                                )}
                            </Box>
                        </Box>

                        {/* Product Description */}
                        <Box sx={{ flex: 2 }}>
                            <Typography variant="h6">
                                ASUS VivoBook 15.6" FHD Thin and Light Laptop with AMD Ryzen 7 5700U, 16GB RAM, 512GB SSD, Windows 11, Backlit Keyboard and Fingerprint Sensor
                            </Typography>
                            <Typography variant="body2" color="text.secondary" mt={1}>
                                <StarRating rating={4.5} />(74 ratings)
                            </Typography>
                            <Typography variant="h4" fontWeight="bold" color="text.primary">
                                AED69<sup style={{ fontSize: '0.6em' }}>99</sup>
                            </Typography>
                            <ShippingInfo />
                            <Box mt={2}>
                                {visibleFeatures.map((spec, index) => (
                                    <Typography key={index} variant="body2">
                                        <strong>{spec.label}:</strong> {spec.value}
                                    </Typography>
                                ))}

                                <Button
                                    variant="text"
                                    size="small"
                                    onClick={() => setFeaturesExpanded(!featuresexpanded)}
                                    sx={{ textTransform: 'none', display: 'flex', alignItems: 'center' }}
                                >
                                    {featuresexpanded ? 'Show less' : 'Show more'}
                                    {featuresexpanded ? <ExpandLessIcon sx={{ ml: 0.5 }} /> : <ExpandMoreIcon sx={{ ml: 0.5 }} />}
                                </Button>
                            </Box>
                            <Divider />
                            <Box mt={2}>
                                <Typography variant="h6" fontWeight={'bold'}>About this item</Typography>
                                {visibleabout.map((about, index) => (
                                    <Box component="ul" sx={{ listStyle: 'disc', pl: 2 }} key={index}>
                                        <Box component="li">{about.value}</Box>
                                    </Box>
                                ))}
                                <Button
                                    variant="text"
                                    size="small"
                                    onClick={() => setAboutExpanded(!aboutexpanded)}
                                    sx={{ textTransform: 'none', display: 'flex', alignItems: 'center' }}
                                >
                                    {aboutexpanded ? 'Show less' : 'Show more'}
                                    {aboutexpanded ? <ExpandLessIcon sx={{ ml: 0.5 }} /> : <ExpandMoreIcon sx={{ ml: 0.5 }} />}
                                </Button>
                            </Box>

                            {/* Mobile Buy Box */}
                            <Box sx={{ display: { xs: 'block', md: 'none' }, mt: 4 }}>
                                <BuyBox quantity={quantity} setQuantity={setQuantity} stockQuantity={stockQuantity} />
                            </Box>
                        </Box>

                        {/* Desktop Buy Box */}
                        <Box sx={{ width: 300, display: { xs: 'none', md: 'block' } }}>
                            <BuyBox quantity={quantity} setQuantity={setQuantity} stockQuantity={stockQuantity} />
                        </Box>
                    </Box>
                </Box>
                {/* end product detail section */}

                {/* Deals on related products */}
                <Box sx={{ padding: '1%' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography
                            sx={{
                                color: darkMode ? '#fff' : '#000',
                                fontSize: '20px',
                                fontWeight: 'bold',
                                mb: 2,
                                display: 'flex',
                                gap: '5px',
                                alignItems: 'center',
                            }}
                        >
                            Deals on related products
                        </Typography>
                    </Box>

                    {/* Carousel Wrapper */}
                    <Box sx={{ position: 'relative' }}>
                        {/* Left Arrow */}
                        <IconButton
                            sx={{
                                position: 'absolute',
                                top: '40%',
                                left: -10,
                                zIndex: 1,
                                backgroundColor: darkMode ? 'black' : 'white',
                                boxShadow: 2,
                                '&:hover': { backgroundColor: darkMode ? '#000' : '#f0f0f0' },
                                display: 'flex',
                                width: 40,
                                height: 40,
                                borderRadius: '50%',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                            onClick={() => scroll1(-300)}
                        >
                            <ArrowBackIosIcon sx={{ ml: '8px' }} />
                        </IconButton>

                        {/* Products */}
                        <Box
                            ref={scrollRef1}
                            sx={{
                                display: 'flex',
                                overflowX: 'auto',
                                gap: 2,
                                scrollBehavior: 'smooth',
                                pb: 1,
                                '&::-webkit-scrollbar': { display: 'none' },
                            }}
                        >
                            {dealsProduct.map((product, index) => (
                                <Card
                                    key={index}
                                    sx={{
                                        minWidth: 220,
                                        flex: '0 0 auto',
                                        borderRadius: 2,
                                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                        transition: 'transform 0.2s ease-in-out',
                                        '&:hover': {
                                            transform: 'translateY(-5px)',
                                            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                        },
                                        border: '1px solid #CBCBCB',
                                        width: '275px'
                                    }}
                                >
                                    <CardMedia component="img" image={product.image} alt={`product-${index}`} sx={{ height: 180, objectFit: 'cover' }} />
                                    <CardContent sx={{ p: 2 }}>
                                        <Box
                                            sx={{
                                                backgroundColor: '#ffe5e5',
                                                color: '#d32f2f',
                                                fontWeight: 'bold',
                                                fontSize: '12px',
                                                display: 'inline-block',
                                                px: 1.5,
                                                py: 0.5,
                                                borderRadius: 1,
                                                mb: 1,
                                            }}
                                        >
                                            {product.discount}
                                        </Box>
                                        <Box sx={{ alignItems: 'center', gap: 1 }}>
                                            <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#C32032' }}>{product.price}</Typography>
                                            <Typography sx={{ fontSize: '14px', color: '#888', textDecoration: 'line-through' }}>{product.oldPrice}</Typography>
                                        </Box>
                                        <StarRating rating={product.rating} />
                                        <Typography sx={{ fontWeight: 500, fontSize: '14px', mb: 0.5 }}>{product.title}</Typography>
                                        <Typography sx={{ fontSize: '13px', color: '#555', mb: 1 }}>{product.size}</Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18" fill="#888">
                                                <path d="M0 0h24v24H0z" fill="none" />
                                                <path d="M12 1a11 11 0 1011 11A11 11 0 0012 1zm0 20a9 9 0 119-9 9 9 0 01-9 9zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                                            </svg>
                                            <Typography sx={{ fontSize: '13px', color: '#555' }}>Ends in: {product.endsIn}</Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            ))}
                        </Box>

                        {/* Right Arrow */}
                        <IconButton
                            sx={{
                                position: 'absolute',
                                top: '40%',
                                right: -10,
                                zIndex: 1,
                                backgroundColor: darkMode ? 'black' : 'white',
                                boxShadow: 2,
                                '&:hover': { backgroundColor: darkMode ? '#000' : '#f0f0f0' },
                                display: 'flex',
                            }}
                            onClick={() => scroll1(300)}
                        >
                            <ArrowForwardIosIcon />
                        </IconButton>
                    </Box>
                </Box>
                {/* end deals on related products */}


                {/* Based on your recent views */}
                <Box sx={{ padding: '1%' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography
                            sx={{
                                color: darkMode ? '#fff' : '#000',
                                fontSize: '20px',
                                fontWeight: 'bold',
                                mb: 2,
                                display: 'flex',
                                gap: '5px',
                                alignItems: 'center',
                            }}
                        >
                            Based on your recent views
                        </Typography>
                    </Box>

                    {/* Carousel Wrapper */}
                    <Box sx={{ position: 'relative' }}>
                        {/* Left Arrow */}
                        <IconButton
                            sx={{
                                position: 'absolute',
                                top: '40%',
                                left: -10,
                                zIndex: 1,
                                backgroundColor: darkMode ? 'black' : 'white',
                                boxShadow: 2,
                                '&:hover': { backgroundColor: darkMode ? '#000' : '#f0f0f0' },
                                display: 'flex',
                                width: 40,
                                height: 40,
                                borderRadius: '50%',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                            onClick={() => scroll2(-300)}
                        >
                            <ArrowBackIosIcon sx={{ ml: '8px' }} />
                        </IconButton>

                        {/* Products */}
                        <Box
                            ref={scrollRef2}
                            sx={{
                                display: 'flex',
                                overflowX: 'auto',
                                gap: 2,
                                scrollBehavior: 'smooth',
                                pb: 1,
                                '&::-webkit-scrollbar': { display: 'none' },
                            }}
                        >
                            {dealsProduct.map((product, index) => (
                                <Card
                                    key={index}
                                    sx={{
                                        minWidth: 220,
                                        flex: '0 0 auto',
                                        borderRadius: 2,
                                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                        transition: 'transform 0.2s ease-in-out',
                                        '&:hover': {
                                            transform: 'translateY(-5px)',
                                            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                        },
                                        border: '1px solid #CBCBCB',
                                        width: '275px'
                                    }}
                                >
                                    <CardMedia component="img" image={product.image} alt={`product-${index}`} sx={{ height: 180, objectFit: 'cover' }} />
                                    <CardContent sx={{ p: 2 }}>
                                        <Box
                                            sx={{
                                                backgroundColor: '#ffe5e5',
                                                color: '#d32f2f',
                                                fontWeight: 'bold',
                                                fontSize: '12px',
                                                display: 'inline-block',
                                                px: 1.5,
                                                py: 0.5,
                                                borderRadius: 1,
                                                mb: 1,
                                            }}
                                        >
                                            {product.discount}
                                        </Box>
                                        <Box sx={{ alignItems: 'center', gap: 1 }}>
                                            <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#C32032' }}>{product.price}</Typography>
                                            <Typography sx={{ fontSize: '14px', color: '#888', textDecoration: 'line-through' }}>{product.oldPrice}</Typography>
                                        </Box>
                                        <StarRating rating={product.rating} />
                                        <Typography sx={{ fontWeight: 500, fontSize: '14px', mb: 0.5 }}>{product.title}</Typography>
                                        <Typography sx={{ fontSize: '13px', color: '#555', mb: 1 }}>{product.size}</Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18" fill="#888">
                                                <path d="M0 0h24v24H0z" fill="none" />
                                                <path d="M12 1a11 11 0 1011 11A11 11 0 0012 1zm0 20a9 9 0 119-9 9 9 0 01-9 9zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                                            </svg>
                                            <Typography sx={{ fontSize: '13px', color: '#555' }}>Ends in: {product.endsIn}</Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            ))}
                        </Box>

                        {/* Right Arrow */}
                        <IconButton
                            sx={{
                                position: 'absolute',
                                top: '40%',
                                right: -10,
                                zIndex: 1,
                                backgroundColor: darkMode ? 'black' : 'white',
                                boxShadow: 2,
                                '&:hover': { backgroundColor: darkMode ? '#000' : '#f0f0f0' },
                                display: 'flex',
                            }}
                            onClick={() => scroll2(300)}
                        >
                            <ArrowForwardIosIcon />
                        </IconButton>
                    </Box>
                </Box>
                {/* end based on your recent views */}
            </Box>
            {/* end body section */}

            {/* Footer */}
            <Footer />
            {/* end footer */}
        </>
    );
}

// Reusable pricing, add to cart & buy now options Component
const BuyBox = ({ quantity, setQuantity, stockQuantity = 0 }: { quantity: number; setQuantity: (value: number) => void; stockQuantity?: number }) => (
    <Box
        sx={{
            border: '1px solid #ccc',
            borderRadius: 2,
            p: 2,
        }}
    >
        <Typography variant="h4" fontWeight="bold" color="text.primary">
            AED69<sup style={{ fontSize: '0.6em' }}>99</sup>
        </Typography>
        <Typography fontSize="14px" mt={1}>
            AED160.67 Shipping & Import Fees Deposit
        </Typography>
        <Typography fontSize="14px" color="text.secondary">AED92.35 delivery</Typography>

        <Typography fontSize="14px" mt={2}>
            📍 Deliver to John - Berlin
        </Typography>

        <Typography mt={2} fontWeight="bold" color={stockQuantity > 0 ? "green" : "error"}>
            {stockQuantity > 0 ? 'In Stock' : 'Out of Stock'}
        </Typography>

        {stockQuantity > 0 && (
            <Box mt={2}>
                <Typography fontSize="14px" mb={1}>Quantity</Typography>
                <Select
                    fullWidth
                    size="small"
                    value={quantity}
                    onChange={(e) => setQuantity(Number(e.target.value))}
                >
                    {Array.from({ length: Math.min(5, stockQuantity) }, (_, index) => index + 1).map((qty) => (
                        <MenuItem key={qty} value={qty}>{qty}</MenuItem>
                    ))}
                </Select>
            </Box>
        )}

        <Box mt={2} display="flex" flexDirection="column" gap={1}>
            <Button disabled={stockQuantity <= 0} variant="outlined" fullWidth sx={{ border: '1px solid #C32032', color: '#C32032' }}>
                {stockQuantity > 0 ? 'Add to Cart' : 'Out of Stock'}
            </Button>
            <Button disabled={stockQuantity <= 0} variant="contained" fullWidth sx={{ bgcolor: '#C32032', color: '#fff' }}>
                Buy Now
            </Button>
        </Box>

        <Typography variant="body2" mt={2}>
            Ships from <strong>FortuneFive.com</strong><br />
            Sold by <strong>FortuneFive.com</strong><br />
            Returns: <u>30-day refund/replacement</u><br />
            Payment: <u>Secure transaction</u>
        </Typography>

        <Button fullWidth sx={{ mt: 2, border: '1px solid #C32032', color: '#C32032' }} variant="outlined">
            Add to List
        </Button>
    </Box>
);

const ShippingInfo = () => {
    const [open, setOpen] = useState(false);
    const darkMode = useSelector((state: any) => state.theme.darkMode);

    return (
        <Box>
            <Box display="flex" alignItems="center" gap={1}>
                <Typography fontSize="14px">
                    AED160.67 Shipping & Import Fees Deposit
                </Typography>
                <Button
                    variant="text"
                    size="small"
                    onClick={() => setOpen((prev) => !prev)}
                    endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    sx={{ textTransform: 'none', fontSize: '14px', minWidth: 'unset' }}
                >
                    Details
                </Button>
            </Box>

            <Collapse in={open}>
                <Box
                    mt={1}
                    sx={{
                        border: '1px solid #ccc',
                        borderRadius: 2,
                        p: 2,
                        maxWidth: 300,
                        bgcolor: darkMode ? '#000' : '#fff',
                    }}
                >
                    <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                        Shipping & Fee Details
                    </Typography>

                    <Box display="flex" justifyContent="space-between">
                        <Typography>Price</Typography>
                        <Typography>AED69<sup>99</sup></Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                        <Typography>FortuneFive Shipping</Typography>
                        <Typography>AED92.35</Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                        <Typography sx={{ color: '#007185', textDecoration: 'underline', cursor: 'pointer' }}>
                            Estimated Import Fees Deposit
                        </Typography>
                        <Typography>AED160.67</Typography>
                    </Box>

                    <Divider sx={{ my: 1 }} />

                    <Box display="flex" justifyContent="space-between">
                        <Typography fontWeight="bold">Total</Typography>
                        <Typography fontWeight="bold">AED322.01</Typography>
                    </Box>
                </Box>
            </Collapse>
        </Box>
    );
};

export default ProductDetail;